export default __webpack_public_path__ + "static/media/q&a.ad6ba532.png";